import React from "react";

import { useTranslation } from "react-i18next";

import { ResponsiveTitleBar, LinkButton } from "../../Atoms";
import { StartTabCheckoutSession } from "../Checkout/TablePayPayment";

export const LetTheGoodTimesRoll = () => {
  const { t } = useTranslation("onsite");
  return (
    <div className="border-y border-dashed border-venue-primary py-32 text-center text-5xl font-bold">
      {t("billSplit.letTheGoodTimes")}
    </div>
  );
};
export const JoinBillSplitSession = ({}: {}) => {
  const { t } = useTranslation("onsite");
  return (
    <div className="mx-auto max-w-screen-sm space-y-32">
      <ResponsiveTitleBar>{t("billSplit.settleUp")} </ResponsiveTitleBar>
      <LetTheGoodTimesRoll />
      <div className="space-y-16">
        <h2 className="text-2xl font-bold">
          {" "}
          {t("billSplit.payForEverything")}
        </h2>
        <StartTabCheckoutSession />
      </div>
      <div className="text-center text-5xl font-bold uppercase leading-loose">
        {t("billSplit.or")}
      </div>
      <div className="space-y-16">
        <h2 className="text-2xl font-bold">
          {t("billSplit.splitBillWithTable")}
        </h2>
        <LinkButton primary to="../customer">
          {t("billSplit.startSplitting")}
        </LinkButton>
      </div>
    </div>
  );
};
